import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { track } from '../../logic';
import { useIsPinPage } from '../../logic/useIsPinPage';
import { ErrorDialog } from './dialogs/ErrorDialog';
import { PinErrorDialogFallbacks } from './dialogs/errorDialogs/pin/PinErrorDialogFallbacks';

const onError = (error: Error, info: {componentStack: string}) => {
  track('error', 'error boundary', {}, {
    message: error.message,
    error: JSON.stringify(error),
    component_stack: info?.componentStack,
  })
}

// IMPROVE: this could show something behind the dialog, maybe a picture of Todd?
function ErrorFallback({error, resetErrorBoundary}: {
  error: any;
  resetErrorBoundary:  React.MouseEventHandler<HTMLButtonElement>;
}) {
  const isPinPage = useIsPinPage() 
  if (isPinPage) {
    return (
      <PinErrorDialogFallbacks error={ error } />
    )
  }
  return (
    <ErrorDialog error={error} errorBoundaryHandler={resetErrorBoundary} />
  )
}

export const ErrorBoundary = ({ children }: {
	children: JSX.Element;
}) => {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={onError}
      onReset={() => {
        track('try_again', 'error boundary')
        // IMPROVE: anything clever to do here to help? At some point, reloadiing
        // might be baaaad.
        window.location.reload()
      }}
    >
      {children}
    </ReactErrorBoundary>
  )
}
